import React from 'react';

import {  Timeline } from '@primer/react';

import ModelAssociationItem from './ModelAssociationItem';

export const AssociationListItem = ({
  modelID,
  modelVersion,
  pipelineID,
  pipelineVersion,
}) => {
  if (modelID) {
    return (
      <ModelAssociationItem
        modelID={modelID}
        modelVersion={modelVersion}
        pipelineID={pipelineID}
        pipelineVersion={pipelineVersion}
      />
    );
  }
  
  return <Timeline.Break />
}

export default AssociationListItem;
